var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1233 14.6703V8.86815L15.3987 11.7697L10.1233 14.6703ZM21.8841 7.11346C21.6495 6.28137 20.9618 5.62627 20.0885 5.40443C18.5047 5 12.1543 5 12.1543 5C12.1543 5 5.80384 5 4.22003 5.40443C3.34586 5.62627 2.65816 6.28137 2.42443 7.11346C2 8.62227 2 11.7696 2 11.7696C2 11.7696 2 14.9162 2.42443 16.4242C2.65816 17.2563 3.34586 17.9122 4.22003 18.1348C5.80384 18.5385 12.1543 18.5385 12.1543 18.5385C12.1543 18.5385 18.5047 18.5385 20.0885 18.1348C20.9618 17.9122 21.6495 17.2563 21.8841 16.4242C22.3077 14.9162 22.3077 11.7696 22.3077 11.7696C22.3077 11.7696 22.3077 8.62227 21.8841 7.11346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.07c2a4b6af2cadd6bb0d8c78b2f4da1b.svg";
export { ForwardRef as ReactComponent };